import styled from 'styled-components';

export const WarningMessage = styled.span`
    width: 100%;
    margin: 10px 0;
    padding: 0 16px;
`;

export const SearchGroup = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;

    .search-container {
        width: auto;
    }

`;
